<ramme-med-tittel [tittel]="'Møteevalueringer'|translate">
  <ramme-innhold>
    @if (aktivert()) {
      @if (moeteVurderinger().length === 0) {
        <div class="tittel">
          <span>{{ 'Ingen møter har blitt evaluert enda.' | translate }}</span>
          <mat-slide-toggle class="e2e-toggle-aktiv" [checked]="aktivert()" (change)="endreAktiveringsstatusForMoeteevaluering($event.checked)">
            {{ 'Møteevaluering aktivert' | translate }}
          </mat-slide-toggle>
        </div>

      } @else {
        <div class="tittel">
          <span id="gruppe-møteevaluering-graf-tittel">{{ 'Møteevalueringer for de siste 12 måneder' | translate }}</span>
          <mat-slide-toggle class="e2e-toggle-aktiv" [checked]="aktivert()" (change)="endreAktiveringsstatusForMoeteevaluering($event.checked)">
            {{ 'Møteevaluering aktivert' | translate }}
          </mat-slide-toggle>
        </div>

        <c3-graf [konfigurasjon]="c3Konfigurasjon()" hoeyde="150px" bredde="100%" ariaLabelledBy="gruppe-møteevaluering-graf-tittel" data-testid="graf"/>

        @if (valgtMoete()) {
          <h2 id="gruppe-møteevaluering-valgt-møte-tittel">
            {{ 'Evaluering av møte {moetenummer}, {moetedato}' | translate:{moetenummer: valgtMoete()?.moetenummer, moetedato: (valgtMoete()?.moetestart | zoneddatetimeSomPlaindate | plaindate:'short')} }}
          </h2>
          <rangering-resultater-soeylediagram [resultater]="valgtMoeteAggregater()!" [oppsett]="diagramoppsett()" ariaLabelledBy="gruppe-møteevaluering-valgt-møte-tittel" data-testid="møtevurdering"/>
        } @else {
          <tips class="ingen-møter-valgt">
            {{ 'Klikk på et datapunkt' | translate }}
            <i class="datapunkt-ikon"></i>
            {{ 'for å se detaljer for et møte' | translate }}
          </tips>
        }
      }

    } @else {
      <div class="ikke-aktivert">
        <tips>
          <p>{{ 'Møteevalueringer er ikke aktivert' | translate }}</p>
          <p>{{ 'Dermed sendes det ikke ut epost med oppfordring om å evaluere møter' | translate }}</p>
          <button mat-button color="primary" (click)="endreAktiveringsstatusForMoeteevaluering(true)" data-testid="aktiver-knapp">
            {{ 'Aktiver møteevaluering' | translate }}
          </button>
        </tips>
      </div>
    }
  </ramme-innhold>
</ramme-med-tittel>

